import type {
  DateString,
  DatetimeNoTzString,
  TimeString,
} from '#/types/TypedDateString';
import { log } from '#/utils/logging';

const DATETIME_NO_TZ_REGEX =
  /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(?:\.\d+)?$/;

export function splitDatetimeNoTzString(datetimeNoTz: DatetimeNoTzString): {
  date: DateString;
  time: TimeString;
} {
  if (!DATETIME_NO_TZ_REGEX.test(datetimeNoTz))
    log.error(`Invalid datetimeNoTz format for ${datetimeNoTz}`);

  const [date, timeMaybeMs] = datetimeNoTz.split('T') as [
    DateString,
    TimeString,
  ];

  return { date, time: timeMaybeMs.split('.')[0] };
}

export function asDatetimeNoTzString({
  date,
  time,
}: {
  date: DateString;
  time: TimeString;
}): DatetimeNoTzString {
  return date + 'T' + time;
}
